import { env } from "~/env";
import { Card } from "~/screens/Hub/Home/components";
import { customIcons } from "~/ui";

export const ClinicalCare = () => (
  <Card title="Clinical care" className="items-start space-y-3">
    <div className="w-full space-y-2 text-left">
      <ul className="text-indigo list-disc space-y-1 pl-6">
        <li>Upcoming appointment information</li>
        <li>Cancelling or rescheduling appointments</li>
        <li>Pharmacy/prescriptions</li>
        <li>Billing/payments</li>
      </ul>
    </div>

    <div className="w-full space-y-3">
      <div className="flex items-center gap-1">
        <customIcons.Message className="text-violet" aria-hidden="true" />
        <span className="text-indigo">Text or call:</span>
        <a
          href="tel:6467606669"
          className="text-violet font-medium hover:underline"
        >
          {env.VITE_SUPPORT_PHONE_NUMBER}
        </a>
      </div>

      <div className="flex items-center gap-1">
        <customIcons.Email className="text-violet" aria-hidden="true" />
        <span className="text-indigo">Email:</span>
        <a
          href={`mailto:${env.VITE_ELEKTRA_CARE_EMAIL}`}
          className="text-violet font-medium hover:underline"
        >
          {env.VITE_ELEKTRA_CARE_EMAIL}
        </a>
      </div>
    </div>
  </Card>
);
